export const HOST = process.env.REACT_APP_URL || 'http://localhost:8000';

export const LANGUAGE_OPTION = [
  { value: 'en_US', label: 'English' },
  { value: 'es_ES', label: 'Spanish' },
];

export const TIMEZONE_OPTION = [
  {
    value: 'America/Puerto_Rico',
    label: 'PR',
  },
  { value: 'America/New_York', label: 'EST' },
  { value: 'America/Los_Angeles', label: 'PST' },
  { value: 'America/Chicago', label: 'CST' },
  { value: 'America/Phoenix', label: 'MST' },
];

export const INDUSTRY = [
  {
    value: 'HEALTHCARE',
    label: 'HEALTHCARE',
  },
  {
    value: 'BASE',
    label: 'OTHER',
  },
];

export const CALENDAR_DISPLAY_NAME: { [key: number]: string } = {
  0: 'BrainHi',
  1: 'Open Dental',
  2: 'SecureClaim',
  3: 'Practice Fusion',
};

export const LANGUAGE_DISPLAY_NAME: { [key: string]: string } = {
  en_US: 'English',
  es_ES: 'Spanish',
};

export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[a-zA-Z]{2,63}$/;
export const ZIP_CODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;

export enum ValidAreaCode {
  // PUERTO RICO
  PR_1 = '787',
  PR_2 = '939',

  // UNITED STATES
  // Alabama
  US_AL_1 = '205',
  US_AL_2 = '251',
  US_AL_3 = '256',
  US_AL_4 = '334',
  US_AL_5 = '938',

  // Alaska
  US_AK_1 = '907',

  // Arizona
  US_AZ_1 = '480',
  US_AZ_2 = '520',
  US_AZ_3 = '602',
  US_AZ_4 = '623',
  US_AZ_5 = '928',

  // Arkansas
  US_AR_1 = '479',
  US_AR_2 = '501',
  US_AR_3 = '870',

  // California
  US_CA_1 = '209',
  US_CA_2 = '213',
  US_CA_3 = '279',
  US_CA_4 = '310',
  US_CA_5 = '323',
  US_CA_6 = '408',
  US_CA_7 = '415',
  US_CA_8 = '424',
  US_CA_9 = '442',
  US_CA_10 = '510',
  US_CA_11 = '530',
  US_CA_12 = '559',
  US_CA_13 = '562',
  US_CA_14 = '619',
  US_CA_15 = '626',
  US_CA_16 = '628',
  US_CA_17 = '650',
  US_CA_18 = '657',
  US_CA_19 = '661',
  US_CA_20 = '669',
  US_CA_21 = '707',
  US_CA_22 = '714',
  US_CA_23 = '747',
  US_CA_24 = '760',
  US_CA_25 = '805',
  US_CA_26 = '818',
  US_CA_27 = '820',
  US_CA_28 = '831',
  US_CA_29 = '858',
  US_CA_30 = '909',
  US_CA_31 = '916',
  US_CA_32 = '925',
  US_CA_33 = '949',
  US_CA_34 = '951',

  // Colorado
  US_CO_1 = '303',
  US_CO_2 = '719',
  US_CO_3 = '720',
  US_CO_4 = '970',

  // Connecticut
  US_CT_1 = '203',
  US_CT_2 = '475',
  US_CT_3 = '860',
  US_CT_4 = '959',

  // Delaware
  US_DE_1 = '302',

  // Florida
  US_FL_1 = '239',
  US_FL_2 = '305',
  US_FL_3 = '321',
  US_FL_4 = '352',
  US_FL_5 = '386',
  US_FL_6 = '407',
  US_FL_7 = '561',
  US_FL_8 = '727',
  US_FL_9 = '754',
  US_FL_10 = '772',
  US_FL_11 = '786',
  US_FL_12 = '813',
  US_FL_13 = '850',
  US_FL_14 = '863',
  US_FL_15 = '904',
  US_FL_16 = '941',
  US_FL_17 = '954',

  // Georgia
  US_GA_1 = '229',
  US_GA_2 = '404',
  US_GA_3 = '470',
  US_GA_4 = '478',
  US_GA_5 = '678',
  US_GA_6 = '706',
  US_GA_7 = '762',
  US_GA_8 = '770',
  US_GA_9 = '912',

  // Hawaii
  US_HI_1 = '808',

  // Idaho
  US_ID_1 = '208',
  US_ID_2 = '986',

  // Illinois
  US_IL_1 = '217',
  US_IL_2 = '224',
  US_IL_3 = '309',
  US_IL_4 = '312',
  US_IL_5 = '331',
  US_IL_6 = '618',
  US_IL_7 = '630',
  US_IL_8 = '708',
  US_IL_9 = '773',
  US_IL_10 = '779',
  US_IL_11 = '815',
  US_IL_12 = '847',
  US_IL_13 = '872',

  // Indiana
  US_IN_1 = '219',
  US_IN_2 = '260',
  US_IN_3 = '317',
  US_IN_4 = '463',
  US_IN_5 = '574',
  US_IN_6 = '765',
  US_IN_7 = '812',
  US_IN_8 = '930',

  // Iowa
  US_IA_1 = '319',
  US_IA_2 = '515',
  US_IA_3 = '563',
  US_IA_4 = '641',
  US_IA_5 = '712',

  // Kansas
  US_KS_1 = '316',
  US_KS_2 = '620',
  US_KS_3 = '785',
  US_KS_4 = '913',

  // Kentucky
  US_KY_1 = '270',
  US_KY_2 = '364',
  US_KY_3 = '502',
  US_KY_4 = '606',
  US_KY_5 = '859',

  // Louisiana
  US_LA_1 = '225',
  US_LA_2 = '318',
  US_LA_3 = '337',
  US_LA_4 = '504',
  US_LA_5 = '985',

  // Maine
  US_ME_1 = '207',

  // Maryland
  US_MD_1 = '240',
  US_MD_2 = '301',
  US_MD_3 = '410',
  US_MD_4 = '443',
  US_MD_5 = '667',

  // Massachusetts
  US_MA_1 = '339',
  US_MA_2 = '351',
  US_MA_3 = '413',
  US_MA_4 = '508',
  US_MA_5 = '617',
  US_MA_6 = '774',
  US_MA_7 = '781',
  US_MA_8 = '857',
  US_MA_9 = '978',

  // Michigan
  US_MI_1 = '231',
  US_MI_2 = '248',
  US_MI_3 = '269',
  US_MI_4 = '313',
  US_MI_5 = '517',
  US_MI_6 = '586',
  US_MI_7 = '616',
  US_MI_8 = '734',
  US_MI_9 = '810',
  US_MI_10 = '906',
  US_MI_11 = '947',
  US_MI_12 = '989',

  // Minnesota
  US_MN_1 = '218',
  US_MN_2 = '320',
  US_MN_3 = '507',
  US_MN_4 = '612',
  US_MN_5 = '651',
  US_MN_6 = '763',
  US_MN_7 = '952',

  // Mississippi
  US_MS_1 = '228',
  US_MS_2 = '601',
  US_MS_3 = '662',
  US_MS_4 = '769',

  // Missouri
  US_MO_1 = '314',
  US_MO_2 = '417',
  US_MO_3 = '573',
  US_MO_4 = '636',
  US_MO_5 = '660',
  US_MO_6 = '816',

  // Montana
  US_MT_1 = '406',

  // Nebraska
  US_NE_1 = '308',
  US_NE_2 = '402',
  US_NE_3 = '531',

  // Nevada
  US_NV_1 = '702',
  US_NV_2 = '725',
  US_NV_3 = '775',

  // New Hampshire
  US_NH_1 = '603',

  // New Jersey
  US_NJ_1 = '201',
  US_NJ_2 = '551',
  US_NJ_3 = '609',
  US_NJ_4 = '640',
  US_NJ_5 = '732',
  US_NJ_6 = '848',
  US_NJ_7 = '856',
  US_NJ_8 = '862',
  US_NJ_9 = '908',
  US_NJ_10 = '973',

  // New Mexico
  US_NM_1 = '505',
  US_NM_2 = '575',

  // New York
  US_NY_1 = '212',
  US_NY_2 = '315',
  US_NY_3 = '332',
  US_NY_4 = '347',
  US_NY_5 = '516',
  US_NY_6 = '518',
  US_NY_7 = '585',
  US_NY_8 = '607',
  US_NY_9 = '631',
  US_NY_10 = '646',
  US_NY_11 = '680',
  US_NY_12 = '716',
  US_NY_13 = '718',
  US_NY_14 = '838',
  US_NY_15 = '845',
  US_NY_16 = '914',
  US_NY_17 = '917',
  US_NY_18 = '929',
  US_NY_19 = '934',

  // North Carolina
  US_NC_1 = '252',
  US_NC_2 = '336',
  US_NC_3 = '704',
  US_NC_4 = '743',
  US_NC_5 = '828',
  US_NC_6 = '910',
  US_NC_7 = '919',
  US_NC_8 = '980',
  US_NC_9 = '984',

  // North Dakota
  US_ND_1 = '701',

  // Ohio
  US_OH_1 = '216',
  US_OH_2 = '220',
  US_OH_3 = '234',
  US_OH_4 = '330',
  US_OH_5 = '380',
  US_OH_6 = '419',
  US_OH_7 = '440',
  US_OH_8 = '513',
  US_OH_9 = '567',
  US_OH_10 = '614',
  US_OH_11 = '740',
  US_OH_12 = '937',

  // Oklahoma
  US_OK_1 = '405',
  US_OK_2 = '539',
  US_OK_3 = '580',
  US_OK_4 = '918',

  // Oregon
  US_OR_1 = '458',
  US_OR_2 = '503',
  US_OR_3 = '541',
  US_OR_4 = '971',

  // Pennsylvania
  US_PA_1 = '215',
  US_PA_2 = '223',
  US_PA_3 = '267',
  US_PA_4 = '272',
  US_PA_5 = '412',
  US_PA_6 = '445',
  US_PA_7 = '484',
  US_PA_8 = '570',
  US_PA_9 = '610',
  US_PA_10 = '717',
  US_PA_11 = '724',
  US_PA_12 = '814',
  US_PA_13 = '878',

  // Rhode Island
  US_RI_1 = '401',

  // South Carolina
  US_SC_1 = '803',
  US_SC_2 = '843',
  US_SC_3 = '854',
  US_SC_4 = '864',

  // South Dakota
  US_SD_5 = '605',

  // Tennessee
  US_TN_1 = '423',
  US_TN_2 = '615',
  US_TN_3 = '629',
  US_TN_4 = '731',
  US_TN_5 = '865',
  US_TN_6 = '901',
  US_TN_7 = '931',

  // Texas
  US_TX_1 = '210',
  US_TX_2 = '214',
  US_TX_3 = '254',
  US_TX_4 = '281',
  US_TX_5 = '325',
  US_TX_6 = '346',
  US_TX_7 = '361',
  US_TX_8 = '409',
  US_TX_9 = '430',
  US_TX_10 = '432',
  US_TX_11 = '469',
  US_TX_12 = '512',
  US_TX_13 = '682',
  US_TX_14 = '713',
  US_TX_15 = '726',
  US_TX_16 = '737',
  US_TX_17 = '806',
  US_TX_18 = '817',
  US_TX_19 = '830',
  US_TX_20 = '832',
  US_TX_21 = '903',
  US_TX_22 = '915',
  US_TX_23 = '936',
  US_TX_24 = '940',
  US_TX_25 = '956',
  US_TX_26 = '972',
  US_TX_27 = '979',

  // Utah
  US_UT_1 = '385',
  US_UT_2 = '435',
  US_UT_3 = '801',

  // Vermont
  US_VT_1 = '802',

  // Virginia
  US_VA_1 = '276',
  US_VA_2 = '434',
  US_VA_3 = '540',
  US_VA_4 = '571',
  US_VA_5 = '703',
  US_VA_6 = '757',
  US_VA_7 = '804',

  // Washington
  US_WA_1 = '206',
  US_WA_2 = '253',
  US_WA_3 = '360',
  US_WA_4 = '425',
  US_WA_5 = '509',
  US_WA_6 = '564',

  // District of Columbia
  US_DC_1 = '202',

  // West Virginia
  US_WV_1 = '304',
  US_WV_2 = '681',

  // Wisconsin
  US_WI_1 = '262',
  US_WI_2 = '414',
  US_WI_3 = '534',
  US_WI_4 = '608',
  US_WI_5 = '715',
  US_WI_6 = '920',

  // Wyoming
  US_WY_1 = '307',
}
